export default __webpack_public_path__ + "static/media/user_avatar.6bf7361f.png";